import { toast } from 'react-toastify';
import { call, put, takeLatest } from 'redux-saga/effects';
import { error, request, success } from 'store/api/actions';
import { baseApi } from 'store/api/apiRequestBuilder';
import { camelize } from 'utils/camelize';
import { logger } from 'utils/logger';

import { patchUserInfo } from '../actions';
import actionTypes from '../actionTypes';
import { updateUserState } from '../reducer';

export function* patchUserInfoSaga({ type, payload: { formData, setSubmitting } }: ReturnType<typeof patchUserInfo>) {
  yield put(request(type));

  try {
    const { data } = yield call(baseApi.patchSelfInfo, formData);

    logger('patch response', data);

    if (data?.display_name === 'this display_name is occupied') {
      toast.error('This name is occupied');
      yield put(error(type));
      return;
    }

    if (data?.custom_url && data?.custom_url[0] === 'user with this custom url already exists.') {
      toast.error('This url is occupied');
      yield put(error(type));
      return;
    }

    yield put(updateUserState({ ...camelize(data) }));

    toast.success('Profile info updated');

    yield put(success(type));
  } catch (e) {
    yield put(error(type, e));
    toast.error('Something went wrong');
    logger('patchUserInfo', e, 'error');
  } finally {
    setSubmitting(false);
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.PATCH_USER_INFO, patchUserInfoSaga);
}
